export const REQUIRED_STEP_KEYS = [
  "syncDatabase",
  "domainAuth",
  "emailFooter",
  "ownerAssignment",
  "databaseNoteTypes",
  "brandAssets",
  "onboardingCall",
];

export const OPTIONAL_STEP_KEYS = [
  "appJobStatus",
  "websiteTracking",
];

const makeStepEntry = () => ({ completed: false, completedAt: null });

// Fallback until the backend returns the regional link.
export const DEFAULT_BOOKING_URL = "https://join.roi-ai.com/meetings/deb-udy/laura-or-deb";

export const initialState = {
  bookingUrl: DEFAULT_BOOKING_URL,

  // Fail-open: don't gate until the backend says otherwise.
  requiresOnboarding: false,

  stepStatus: {
    syncDatabase:        makeStepEntry(),
    domainAuth:          makeStepEntry(),
    emailFooter:         makeStepEntry(),
    ownerAssignment:     makeStepEntry(),
    databaseNoteTypes:   makeStepEntry(),
    brandAssets:         makeStepEntry(),
    onboardingCall:      makeStepEntry(),
  },

  optionalStepStatus: {
    appJobStatus:    makeStepEntry(),
    websiteTracking: makeStepEntry(),
  },

  isLoadingSetup:  false,   // true while GET /Setup/GetStatus is in-flight
  isSavingStep:    null,    // stepKey currently being saved (string), or null
  error:           null,    // last error message string, or null
  hasFetched:      false,   // becomes true once initial load completes (success or fail)
};
